(($) => {
    let $checked;

    window.addEventListener('load', init);

    function init() {
        $checked = $('[class*="force-checked"]');
        $checked.each(forceCheck);
    }

    function forceCheck(elIndex, el) {
        if (typeof el == 'undefined') {
            return false;
        }

        let $el = $(el);
        let classes = $el.attr('class').split(' ');

        for (let i=0; i < classes.length; i++) {

            if (classes[i].indexOf('force-checked') == -1) {
                continue;
            }

            if (classes[i] == 'force-checked') {
                if ($el.is('input')) {
                    check($el);
                } else {
                    check($el.find('input'));
                    break;
                }
            }

            if (classes[i].indexOf('force-checked-') == -1) {
                continue;
            }

            let n = Number(classes[i].split('force-checked-'));

            if (isNaN(n)) {
                continue;
            }

            check($el.find('input').eq(n));
        }
    }

    function check($el) {
        if (typeof $el == 'undefined') {
            return false;
        } 
        setTimeout(() => {
            $el.attr('checked', 'checked');
        }, 100);
    }

})(jQuery);